/**
 * Import Process Polling Mixin
 * Handles generic process polling for imports (upload, execution, intermediate steps)
 */
export default {
    methods: {
        /**
         * Generic process polling method (reusable for different process types)
         */
        pollGenericProcess(process_id, onSuccess, onError, onProgress = null) {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/process/:process_id',
                'params': {
                    'process_id': process_id
                },
                'on_success': (data) => {
                    if (data.state === 'finished') {
                        onSuccess(data);
                    } else if (data.state === 'failed') {
                        onError(data.exception || 'Process failed');
                    } else {
                        // Call progress callback if provided
                        if (onProgress) {
                            onProgress(data);
                        }
                        // Continue polling
                        setTimeout(() => this.pollGenericProcess(process_id, onSuccess, onError, onProgress), 1000);
                    }
                },
                'on_error': (error) => {
                    onError(`Process polling failed: ${error}`);
                }
            });
        }
    }
};
